const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPickupStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 56,
    viewBox: "0 0 400 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    y1: 27,
    x2: 16,
    y2: 27,
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 27.9987L42.6665 30.6654L47.9998 25.332M33.1331 23.4922C32.9385 22.6155 32.9684 21.704 33.22 20.8419C33.4716 19.9799 33.9368 19.1954 34.5724 18.5611C35.208 17.9268 35.9935 17.4633 36.856 17.2135C37.7186 16.9637 38.6302 16.9357 39.5064 17.1322C39.9887 16.3779 40.6531 15.7572 41.4384 15.3272C42.2236 14.8972 43.1045 14.6719 43.9998 14.6719C44.895 14.6719 45.7759 14.8972 46.5612 15.3272C47.3464 15.7572 48.0108 16.3779 48.4931 17.1322C49.3707 16.9349 50.2839 16.9627 51.1478 17.2131C52.0117 17.4635 52.7982 17.9283 53.4342 18.5644C54.0702 19.2004 54.5351 19.9869 54.7855 20.8508C55.0359 21.7147 55.0637 22.6279 54.8664 23.5055C55.6207 23.9878 56.2414 24.6522 56.6714 25.4374C57.1014 26.2227 57.3267 27.1036 57.3267 27.9988C57.3267 28.8941 57.1014 29.775 56.6714 30.5602C56.2414 31.3455 55.6207 32.0099 54.8664 32.4922C55.0629 33.3684 55.0349 34.28 54.7851 35.1426C54.5353 36.0051 54.0718 36.7906 53.4375 37.4262C52.8032 38.0618 52.0187 38.527 51.1566 38.7786C50.2946 39.0302 49.3831 39.0601 48.5064 38.8655C48.0248 39.6226 47.3599 40.246 46.5733 40.6779C45.7867 41.1098 44.9038 41.3362 44.0064 41.3362C43.1091 41.3362 42.2262 41.1098 41.4396 40.6779C40.653 40.246 39.9881 39.6226 39.5064 38.8655C38.6302 39.0619 37.7186 39.034 36.856 38.7842C35.9935 38.5344 35.208 38.0708 34.5724 37.4365C33.9368 36.8022 33.4716 36.0177 33.22 35.1557C32.9684 34.2937 32.9385 33.3821 33.1331 32.5055C32.373 32.0245 31.747 31.3591 31.3132 30.5711C30.8793 29.7832 30.6519 28.8983 30.6519 27.9988C30.6519 27.0994 30.8793 26.2145 31.3132 25.4265C31.747 24.6386 32.373 23.9732 33.1331 23.4922Z",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 27,
    x2: 172,
    y2: 27,
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.667 40.9758C199.072 41.2099 199.532 41.3331 200 41.3331C200.468 41.3331 200.928 41.2099 201.333 40.9758L210.667 35.6425C211.072 35.4087 211.408 35.0725 211.642 34.6676C211.876 34.2627 212 33.8034 212 33.3358V22.6691C212 22.2015 211.876 21.7422 211.642 21.3374C211.408 20.9325 211.072 20.5963 210.667 20.3625L201.333 15.0291C200.928 14.7951 200.468 14.6719 200 14.6719C199.532 14.6719 199.072 14.7951 198.667 15.0291L189.333 20.3625C188.928 20.5963 188.592 20.9325 188.358 21.3374C188.124 21.7422 188 22.2015 188 22.6691V33.3358C188 33.8034 188.124 34.2627 188.358 34.6676C188.592 35.0725 188.928 35.4087 189.333 35.6425L198.667 40.9758Z",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 41.3333V28",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.387 21.3359L200 28.0026L211.613 21.3359",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 17.6914L206 24.5581",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228,
    y1: 27,
    x2: 328,
    y2: 27,
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.667 39.9974C367.244 39.9974 369.333 37.9081 369.333 35.3307C369.333 32.7534 367.244 30.6641 364.667 30.6641C362.089 30.6641 360 32.7534 360 35.3307C360 37.9081 362.089 39.9974 364.667 39.9974Z",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.333 39.9974C349.91 39.9974 351.999 37.9081 351.999 35.3307C351.999 32.7534 349.91 30.6641 347.333 30.6641C344.755 30.6641 342.666 32.7534 342.666 35.3307C342.666 37.9081 344.755 39.9974 347.333 39.9974Z",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.999 20.0026C360.736 20.0026 361.333 19.4057 361.333 18.6693C361.333 17.9329 360.736 17.3359 359.999 17.3359C359.263 17.3359 358.666 17.9329 358.666 18.6693C358.666 19.4057 359.263 20.0026 359.999 20.0026Z",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 35.3307V30.6641L352 26.6641L357.333 22.6641L360 26.6641H362.667",
    stroke: "#1368F2",
    style: {
      stroke: "#1368F2",
      stroke: "color(display-p3 0.0745 0.4078 0.9490)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPickupStep);
export default __webpack_public_path__ + "static/media/icon_pickup_step.d968415a792d947f2fddefc6bea898ce.svg";
export { ForwardRef as ReactComponent };